import { ITooltipParams } from 'ag-grid-community';
import { ReactElement } from 'react';
import TooltipPanel from 'lib-ui/tooltip/tooltip-panel';

function TableTooltip({ value }: ITooltipParams): ReactElement | null {
    return <TooltipPanel suppressTick>{value}</TooltipPanel>;
}

export default TableTooltip;
